import { NgModule } from '@angular/core';
import { LoginComponent } from './login/login.component';
import { SubscriptionComponent } from './subscription/subscription.component';
import { SharedModule } from '../shared/shared.module';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';

@NgModule({
  declarations: [
    LoginComponent,
    SubscriptionComponent,
    ForgetPasswordComponent
  ],
  imports: [
    SharedModule
  ]
})
export class SignModule { }
